import React from 'react';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
    accordionSummaryClasses,
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import SvgIcon from '@mui/material/SvgIcon';
import MuiAccordionDetails, { AccordionDetailsProps } from '@mui/material/AccordionDetails';
import ArrowUpIcon from '../../../../public/static/icons/arrowUpV2.svg';
import { colorsUnifications } from '../../../style/global-style';

export const Accordion = (props: AccordionProps) => {
    return (
        <MuiAccordion
            {...props}
            sx={{
                padding: '0',
                borderRadius: '6px',
                marginBottom: '16px',
                boxShadow: '0 6px 8px rgba(0,0,0,.02)',
                [`&:before`]: {
                    display: 'none',
                },
            }}
        />
    );
};

export const AccordionHead = (props: AccordionSummaryProps) => {
    return (
        <MuiAccordionSummary
            {...props}
            expandIcon={
                <SvgIcon
                    inheritViewBox
                    component={ArrowUpIcon}
                    sx={{
                        transform: 'rotate(180deg)',
                        color: colorsUnifications.azure[100],
                    }}
                />
            }
            sx={{
                [`.${accordionSummaryClasses.content}`]: {
                    display: 'flex',
                    flexDirection: 'column',
                    margin: 0,

                    [`&.${accordionSummaryClasses.expanded}`]: {
                        margin: 0,
                    },
                },
                padding: '24px',
            }}
        />
    );
};

export const AccordionCollapseContent = (props: AccordionDetailsProps) => {
    return (
        <MuiAccordionDetails
            {...props}
            sx={{
                padding: '16px 24px',
            }}
        />
    );
};
